import { render, staticRenderFns } from "./PremiumFeature.vue?vue&type=template&id=78c3c291"
import script from "./PremiumFeature.vue?vue&type=script&lang=js"
export * from "./PremiumFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports